interface FaqSectionItem {
  q: string;
  a: string;
}

interface FaqSectionProps {
  items: FaqSectionItem[];
  title?: string;
  eyebrow?: string;
}

export default function FaqSection({
  items,
  title = "Частые вопросы",
  eyebrow = "FAQ",
}: FaqSectionProps) {
  if (!items || items.length === 0) return null;

  return (
    <section
      className="py-28 bg-card border-t border-primary/10"
      aria-labelledby="faq-section-heading"
    >
      <div className="container mx-auto px-6 md:px-14 max-w-3xl">
        <div className="mb-12">
          <div className="text-[9px] tracking-[0.4em] text-primary/50 uppercase mb-4">
            {eyebrow}
          </div>
          <h2
            id="faq-section-heading"
            className="text-4xl md:text-5xl font-serif font-light text-foreground"
          >
            {title}
          </h2>
        </div>
        <div className="border-t border-primary/15">
          {items.map((item, i) => (
            <details
              key={i}
              className="group border-b border-primary/15 py-5"
              {...(i === 0 ? { open: true } : {})}
            >
              <summary className="flex items-start justify-between gap-4 cursor-pointer list-none text-foreground font-light text-lg leading-snug [&::-webkit-details-marker]:hidden">
                <span>{item.q}</span>
                <span className="text-primary/50 text-2xl shrink-0 leading-none mt-0.5 transition-transform duration-300 group-open:rotate-45">
                  +
                </span>
              </summary>
              <p className="mt-4 text-muted-foreground font-light leading-relaxed">
                {item.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
